import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.profiles.profile.main', {
        url: '/main',
        component: 'userProfileMain',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/main/main.state.js